"use client";
import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_KEY, COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_VALUE_ON } from "../../../ConsentManagement/constants.js";
import { useSessionStorage } from "../../../../hooks/useSessionStorage/index.js";
import { OneTrustButton } from "./OneTrustButton.js";
import { TranscendButton } from "./TranscendButton.js";
function renderOneTrustButton(entry) {
  return /* @__PURE__ */ jsx(OneTrustButton, { entry });
}
function renderTranscendButton(entry) {
  return /* @__PURE__ */ jsx(TranscendButton, { entry });
}
const CookieSettingsLinkClient = ({
  isTranscendConsentManagementEnabled,
  entry
}) => {
  const [isMounted, setIsMounted] = useState(false);
  const [consentProviderSessionStorage] = useSessionStorage(
    COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_KEY,
    isTranscendConsentManagementEnabled
  );
  const isTranscendEnabled = isTranscendConsentManagementEnabled || consentProviderSessionStorage === COOKIE_COMPLIANCE_PROVIDER_SESSION_STORAGE_VALUE_ON;
  useEffect(() => {
    setIsMounted(true);
  }, []);
  if (!isMounted) {
    return null;
  }
  if (isTranscendEnabled) {
    return renderTranscendButton(entry);
  } else {
    return renderOneTrustButton(entry);
  }
};
export {
  CookieSettingsLinkClient
};
